import type { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Error key reused by address restricted-character messaging (no new i18n).
 * Matches ADDRESS_VALIDATION_ERROR_KEYS.restrictedCharacters.
 */
export const EMOJI_VALIDATION_ERROR_KEYS = {
  restrictedCharacters: 'restrictedCharacters',
} as const;

/** Unicode emoji pictographs (covers OM-718 samples such as 😂🤣😄). */
export const EMOJI_PATTERN = /\p{Extended_Pictographic}/u;

/**
 * Returns whether the value contains one or more disallowed emoji characters.
 */
export function containsDisallowedEmoji(value: string): boolean {
  return EMOJI_PATTERN.test(value);
}

/**
 * Rejects values that contain emoji characters.
 */
export function noEmojiValidator(control: AbstractControl): ValidationErrors | null {
  const value = typeof control.value === 'string' ? control.value : '';

  return containsDisallowedEmoji(value)
    ? { [EMOJI_VALIDATION_ERROR_KEYS.restrictedCharacters]: true }
    : null;
}

/**
 * Rejects emoji when a non-blank value is present; blank values are allowed.
 */
export function optionalNoEmojiValidator(control: AbstractControl): ValidationErrors | null {
  const value = typeof control.value === 'string' ? control.value.trim() : '';

  if (!value) {
    return null;
  }

  return noEmojiValidator(control);
}
